import {
  Admin as RaAdmin,
  CustomRoutes,
  type TranslationMessages,
  resolveBrowserLocale
} from 'react-admin'
import { useMediaQuery } from '@mui/material'
import polyglotI18nProvider from 'ra-i18n-polyglot'
import { Route, useParams } from 'react-router-dom'
import log from 'loglevel'
import React from 'react'
import { ja } from './translations-ja'
import { DataProvider } from 'components/DataProvider'
import { Layout } from 'components/Layout'
import { tokenAuthProvider } from 'components/Auth'
import { adminTheme, desktopTtheme, otherTheme } from 'components/Theme'
import LoginPage from 'components/LoginPage'
import ResponseForm from 'components/ResponseForm'
import { isNil } from 'lodash/fp'

log.setLevel(log.levels.DEBUG)

const translations: Record<string, TranslationMessages> = { ja }
const i18nProvider = polyglotI18nProvider(
  (locale) => translations[locale] as TranslationMessages,
  resolveBrowserLocale(),
  [{ locale: 'ja', name: '日本語' }]
  // { allowMissing: true }
)
export const Admin: React.FC = () => {
  const dataProvider = DataProvider()
  const { id } = useParams()
  if (isNil(id)) return
  return (
    <RaAdmin
      basename={`/${id as string}`}
      dataProvider={dataProvider}
      i18nProvider={i18nProvider}
      authProvider={tokenAuthProvider}
      loginPage={LoginPage}
      requireAuth
      layout={Layout}
      lightTheme={otherTheme}
      darkTheme={otherTheme}>
      <CustomRoutes>
        <Route path="/" element={<ResponseForm />} />
      </CustomRoutes>
    </RaAdmin>
  )
}
